"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rectangle = void 0;
var Rectangle = /** @class */ (function () {
    function Rectangle(width, height, x, y) {
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
    }
    /**
     * @param {number} x
     * @returns {Rectangle}
     */
    Rectangle.prototype.setX = function (x) {
        this.x = x;
        return this;
    };
    /**
     * @param {number} y
     * @returns {Rectangle}
     */
    Rectangle.prototype.setY = function (y) {
        this.y = y;
        return this;
    };
    /**
     * @param {number} width
     * @returns {Rectangle}
     */
    Rectangle.prototype.setWidth = function (width) {
        this.width = width;
        return this;
    };
    /**
     * @param {number} height
     * @returns {Rectangle}
     */
    Rectangle.prototype.setHeight = function (height) {
        this.height = height;
        return this;
    };
    return Rectangle;
}());
exports.Rectangle = Rectangle;
//# sourceMappingURL=rectangle.js.map